/* eslint-disable react/prop-types */
import React, { Fragment, Component } from 'react';
import Divider from '@material-ui/core/Divider';
import Typography from "@material-ui/core/Typography";
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import DisplayAdmissionApplications from './HelperChunks/DisplayAdmissionApplications';
import { Link } from 'react-router-dom';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText,
} from "@material-ui/core";
import LoginMenu from '../../../components/LoginMenu/LoginMenu';


function isEmpty(obj) {

    if (obj == null) return true;

    if (obj.length > 0) return false;
    if (obj.length === 0) return true;

    if (typeof obj !== "object") return true;

    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
}

class ReviewAdmissionApplication extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            review: false,
            isNotUploaded: false,
            uploadMsg: "",
            data: {},
            documentsData: [],
            documentsList: [],
            loadingData: false,
            loadingCheck: false,
            loadingSubmit: false,
            firstMsg: "",
            isFormSubmited: false,
            isLoginMenu: false,
            isReload: false,
            successDialog: false

        }
    }

    componentDidMount() {
        this.getCheck();
    }

    getCheck = async () => {
        let documentsData = [];
        let documentsList = [];
        const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationDocumentsReviewApplicationView`;
        this.setState({
            loadingCheck: true
        })
        await fetch(url, {
            method: "GET",
            headers: new Headers({
                Authorization: "Bearer " + localStorage.getItem("uclToken")
            })
        })
            .then(res => {
                if (!res.ok) {
                    throw res;
                }
                return res.json();
            })
            .then(
                async json => {
                    if (json.DATA) {
                        documentsData = json.DATA || [];
                        this.setState({
                            documentsData
                        })
                        if (localStorage.getItem("isSubmitted") != 1) {
                            const urlList = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationRequiredDocumentListView`;
                            await fetch(urlList, {
                                method: "GET",
                                headers: new Headers({
                                    Authorization: "Bearer " + localStorage.getItem("uclToken")
                                })
                            })
                                .then(res => {
                                    if (!res.ok) {
                                        throw res;
                                    }
                                    return res.json();
                                })
                                .then(
                                    json => {
                                        if (json.DATA) {
                                            documentsList = json.DATA || [];
                                        }
                                    },
                                    error => {
                                        console.log(error);
                                    });
                            let { isNotUploaded, uploadMsg, firstMsg } = this.state;
                            let label = "";
                            if (documentsData.length <= 0) {
                                isNotUploaded = true;
                                uploadMsg = '';
                                firstMsg = 'Please scan and upload your supporting documents in Document Upload section';
                            } else {
                                firstMsg = 'Please scan and upload following documents in Document Upload section';
                                const pass = documentsData.find(item => item.documentTypeId === 1);
                                const cnic = documentsData.find(item => item.documentTypeId === 2);
                                const olevel = documentsData.find(item => item.documentTypeId === 4);
                                // const alevel = documentsData.find(item => item.documentTypeId === 5);

                                if (isEmpty(pass)) {
                                    label = documentsList.find(d => d.ID === 1).Label || '';
                                    uploadMsg = `${uploadMsg}${uploadMsg ? ',' : ''} ${label}`;
                                    isNotUploaded = true;
                                }
                                if (isEmpty(cnic)) {
                                    label = documentsList.find(d => d.ID === 2).Label || '';
                                    uploadMsg = `${uploadMsg}${uploadMsg ? ',' : ''} ${label}`;
                                    isNotUploaded = true;
                                }
                                if (documentsData[0].degreeId === 32) {
                                    if (isEmpty(olevel)) {
                                        label = documentsList.find(d => d.ID === 4).Label || '';
                                        uploadMsg = `${uploadMsg}${uploadMsg ? ',' : ''} ${label}`;
                                        isNotUploaded = true;
                                    }
                                }
                                if ((documentsData[0].degreeId >= 2 && documentsData[0].degreeId <= 9) || documentsData[0].degreeId === 13 || documentsData[0].degreeId === 14) {
                                    if (isEmpty(olevel)) {
                                        label = documentsList.find(d => d.ID === 4).Label || '';
                                        uploadMsg = `${uploadMsg}${uploadMsg ? ',' : ''} ${label}`;
                                        isNotUploaded = true;
                                    }
                                    // if (isEmpty(alevel)) {
                                    //     label = documentsList.find(d => d.ID === 5).Label || '';
                                    //     uploadMsg = `${uploadMsg}${uploadMsg ? ',' : ''} ${label}`;
                                    //     isNotUploaded = true;
                                    // }
                                }

                            }

                            this.setState({
                                isNotUploaded,
                                uploadMsg,
                                firstMsg
                            })
                        }
                    }
                },
                error => {
                    if (error.status == 401) {
                        this.setState({
                            isLoginMenu: true,
                            isReload: true
                        })
                    } else {
                        alert('Failed to fetch, Please try again later.');
                        console.log(error);
                    }
                });
        this.setState({
            loadingCheck: false,
        })
    }


    getData = async () => {
        const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationView`;
        this.setState({
            loadingData: true
        })
        await fetch(url, {
            method: "GET",
            headers: new Headers({
                Authorization: "Bearer " + localStorage.getItem("uclToken")
            })
        })
            .then(res => {
                if (!res.ok) {
                    throw res;
                }
                return res.json();
            })
            .then(
                json => {
                    if (json.CODE === 1) {
                        if (json.DATA) {
                            if (json.DATA.length > 0) {
                                this.setState({
                                    data: json.DATA[0] || {},
                                    open: true,
                                    review: true
                                });
                            }
                        }
                    } else {
                        alert(json.USER_MESSAGE + '\n' + json.SYSTEM_MESSAGE)
                    }
                    console.log(json);
                },
                error => {
                    if (error.status == 401) {
                        this.setState({
                            isLoginMenu: true,
                            isReload: false
                        })
                    } else {
                        alert('Failed to fetch, Please try again later.');
                        console.log(error);
                    }
                });
        this.setState({
            loadingData: false,
        })

    }

    onSubmitClick = async () => {
        const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationSubmitApplication`;
        this.setState({
            loadingSubmit: true
        })
        await fetch(url, {
            method: "Post",
            headers: new Headers({
                Authorization: "Bearer " + localStorage.getItem("uclToken")
            })
        })
            .then(res => {
                if (!res.ok) {
                    throw res;
                }
                return res.json();
            })
            .then(
                json => {
                    if (json.CODE === 1) {
                        localStorage.setItem("isSubmitted", 1);
                        this.handleSuccessDialog();
                    } else {
                        alert(json.USER_MESSAGE + '\n' + json.SYSTEM_MESSAGE)
                    }
                    console.log(json);
                },
                error => {
                    if (error.status == 401) {
                        this.setState({
                            isLoginMenu: true,
                            isReload: false
                        })
                    } else {
                        alert('Operation Failed , Please try again later.');
                        console.log(error);
                    }
                });
        this.setState({
            loadingSubmit: false,
        })
    }

    DownloadFile = (fileName) => {
        const data = new FormData();
        data.append("fileName", fileName);
        const url = `${process.env.REACT_APP_API_DOMAIN}/${
            process.env.REACT_APP_SUB_API_NAME
            }/common/CommonViewFile?fileName=${encodeURIComponent(fileName)}`;

        fetch(url, {
            method: "GET",
            headers: new Headers({
                Authorization: "Bearer " + localStorage.getItem("uclToken"),
            }),
        })
            .then((res) => {
                if (res.status === 200) {
                    return res.blob();
                } else if (res.status == 401) {
                    this.setState({
                        isLoginMenu: true,
                        isReload: false
                    })
                    return {}
                } else {
                    alert('Operation Failed, Please try again later.');
                    return {}
                }
            })
            .then((result) => {
                var csvURL = window.URL.createObjectURL(result);
                var tempLink = document.createElement("a");
                tempLink.href = csvURL;
                tempLink.setAttribute("download", fileName);
                tempLink.click();
                console.log(csvURL);
                if (result.CODE == 1) {
                    //Code
                } else if (result.CODE == 2) {
                    alert(
                        "SQL Error (" +
                        result.CODE +
                        "): " +
                        result.USER_MESSAGE +
                        "\n" +
                        result.SYSTEM_MESSAGE
                    );
                } else if (result.CODE == 3) {
                    alert(
                        "Other Error (" +
                        result.CODE +
                        "): " +
                        result.USER_MESSAGE +
                        "\n" +
                        result.SYSTEM_MESSAGE
                    );
                } else if (result.error == 1) {
                    alert(result.error_message);
                } else if (result.success == 0 && result.redirect_url != "") {
                    window.location = result.redirect_url;
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    handleSuccessDialog = () => {
        this.setState({
            successDialog: !this.state.successDialog,
        });
    }

    render() {
        const isSubmitted = localStorage.getItem("isSubmitted");

        return (
            <Fragment>
                <LoginMenu reload={this.state.isReload} open={this.state.isLoginMenu} handleClose={() => this.setState({ isLoginMenu: false })} />

                <Dialog
                    open={this.state.successDialog}
                    disableBackdropClick
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Success"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Your <b>Admission Application</b> and <b>Documents</b> has been Submitted Successfully. Please click next to proceed to the payment of <b>Registration Fee</b>.
            </DialogContentText>
                    </DialogContent>
                    <DialogActions>

                        <Button color="primary" >
                            <Link style={{ textDecoration: 'none' }} to='/dashboard/registration-fee-payment'>
                                Next
              </Link>
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.isNotUploaded}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Incomplete Documents"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {this.state.firstMsg}
                            <div> <strong>{this.state.uploadMsg}</strong> </div>

                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            color="primary"
                            variant="outlined"
                            style={{
                                marginBottom: 10,
                                marginRight: 10,
                                awidth: 150,
                                textTransform: "capitalize",
                                color: "#303F9F",
                                borderColor: "#303F9F",
                            }}
                            disabled={this.state.loadingData}
                        >
                            <Link
                                style={{ textDecoration: "none" }}
                                to="/dashboard/documents"
                            >
                                Go to Upload Documents
              </Link>
                        </Button>
                    </DialogActions>
                </Dialog>

                <DisplayAdmissionApplications documentData={this.state.documentsData} onDownload={fileName => this.DownloadFile(fileName)} data={this.state.data} open={this.state.open} handleClose={() => this.handleClose()} />
                <div style={{ padding: 20 }}>
                    <Typography style={{ color: '#1d5f98', fontWeight: 600, fontSize: 20 }} variant="h5">
                        Review & Submit Admission Application
                </Typography>
                    <Divider style={{
                        backgroundColor: 'rgb(58, 127, 187)',
                        opacity: '0.3'
                    }} />
                </div>
                <div style={{
                    fontSize: 20,
                    marginLeft: 25,
                    marginRight: 25,
                    marginBottom: 20
                }}>
                    Your Admission Application is almost complete. Please click <b>“Review Admission Application”</b>
                   to review your application before submitting to look for any errors
                   (you can only submit after you have reviewed the application). Please click <b>“Edit Application”</b>
                   to make any changes. Once the application is submitted, you will not be able to modify any information
                    in your application. When you are ready to submit, please click <b>“Submit Admission Application”</b>.
                    </div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    marginLeft: '-30px'
                }}>
                    <Button disabled={this.state.loadingData || this.state.loadingCheck || this.state.loadingSubmit} onClick={() => this.getData()} color="primary" variant="contained" style={{
                        width: '300px', textTransform: 'capitalize', fontSize: 18, backgroundColor: '#174A84', marginBottom: 30, color: 'white',
                        marginTop: 30, marginRight: 25
                    }}>
                        {(this.state.loadingData || this.state.loadingCheck) && <CircularProgress style={{ color: 'white', marginRight: 10 }} size={24} />} {(this.state.loadingData || this.state.loadingCheck) ? 'Please Wait...' : isSubmitted == 0 ? 'Review Admission Application' : 'View Admission Application'}
                    </Button>
                    {isSubmitted == 0 && (
                        <Button color="primary" variant="contained" style={{
                            width: '300px', textTransform: 'capitalize', fontSize: 18, backgroundColor: '#174A84', marginBottom: 30, color: 'white',
                            marginTop: 30, marginRight: 25
                        }}>
                            <Link style={{ textDecoration: 'none', textTransform: 'capitalize', fontSize: 18, backgroundColor: '#174A84', color: 'white' }} to='/dashboard/admission-application'>
                                Edit Admission Application
                            </Link>
                        </Button>


                    )

                    }
                    {isSubmitted == 0 && (

                        <Button disabled={!this.state.review || this.state.loadingSubmit} onClick={() => this.onSubmitClick()} color="primary" variant="contained" style={{ width: '300px', textTransform: 'capitalize', color: 'white', fontSize: 18, backgroundColor: `${this.state.review ? '#174A84' : 'hsl(212, 8%, 75%)'}` }}>
                            {this.state.loadingSubmit && <CircularProgress style={{ color: 'white', marginRight: 10 }} size={24} />} {this.state.loadingSubmit ? 'Please Wait...' : 'Submit Admission Application'}
                        </Button>

                    )

                    }


                </div>
            </Fragment >
        );
    }
}

export default ReviewAdmissionApplication;